import React, { useEffect, useState } from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import ItemTags from "components/MainApp/organisms/OrdersV4/Item-Tags";
import LocationSummary from "components/MainApp/organisms/OrdersV4/LocationSummary";
import tagIcon from "assets/images/tag-icon.svg";
import locationIcon from "assets/images/location-icon.svg";
import styles from "./LoadReceptionOrder.step3.module.scss";
import i18n from "i18n";
import { Collapse, ListItemButton } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { List } from "@material-ui/core";
import Icon from "components/MainApp/atoms/Icon/icon";
import calendarIcon from "assets/images/calendar-icon.svg";
import trashIcon from "assets/images/trash-icon.svg";

export const ReceptionOrderStep3 = ({
  itemsLocateds,
  itemsNoLocateds,
  handleDelete,
  handleSelect,
  allSelecteds,
  handleSelectAll,
  title,
  goBackFunc,
}) => {

  const [itemsList, setItemsList] = useState([]);

  useEffect(() => {
    if (itemsLocateds && itemsLocateds.length > 0) {
      setItemsList(itemsLocateds.flatMap((item) =>
        Array.isArray(item.items) ?
          item.items.map((itemData) => ({
            ...itemData,
            itemData: item,
            title: item.title,
            dispatch_area: item.dispatch_area,
          })) : []
      ))
    } else {
      setItemsList([]);
    }
  }, [itemsLocateds]);

  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  const stepContent = (
    <div className={styles["reception-order-step-three-content"]}>
      {itemsLocateds &&
        <div className={styles["reception-order-step-three__tags-located"]}>
          <ListItemButton onClick={handleClick} className={styles["reception-order-step-three__tags-located"]}>
            <article>
              <div>
                <picture>
                  <img src={locationIcon} alt="tag icon" />
                </picture>
                <h4>{i18n.t("tags.with.locations")}</h4>
              </div>
              <span >{itemsList.length}</span>
              {open ? <ExpandLess /> : <ExpandMore />}
            </article>
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit className={styles["collapse-container"]}>
            <List component="div" disablePadding className={styles["reception-order-step-three-subtitle-locateds-main"]}>
              <div className={styles["reception-order-step-three-subtitle-locateds"]}>
                <div className={styles["epc"]}>
                  EPC
                </div>
                <div className={styles["location"]}>
                  {i18n.t("location")}
                </div>
              </div>
            </List>
            <div>
              {
                itemsList.map((itemData) => {
                  return (
                    itemData.tag && (
                      <List component="div" disablePadding className={styles["location-summary-selected-detail"]}>
                        <div className={styles["location-summary-container"]} key={itemData.tag}>
                          <div className={styles["location-summary-left"]}>
                            <div className={styles["path"]}>{itemData.tag}</div>
                            <img src={calendarIcon} alt="tag icon" />
                            {itemData.dispatch_area && (
                              <div className={styles["items"]}>{i18n.t("new.departure.order")}</div>
                            )}
                          </div>
                          <div className={styles["location-summary-right"]}>
                            <div className={styles["path"]}>{itemData.title}</div>
                            {handleDelete && (
                              <div className={styles["tash-icon"]} onClick={() => handleDelete(itemData.itemData, itemData.tag)}>
                                <img src={trashIcon} alt="tag icon" />
                              </div>
                            )}
                          </div>
                        </div>
                      </List>
                    )
                  )
                })
              }
            </div>
          </Collapse>
        </div>
      }

      <div className={styles["check-all"]}>
        <div className={styles["all-selector"]} onClick={() => handleSelectAll()}>
          <Checkbox checked={allSelecteds} />
        </div>
        {i18n.t("all.products")}
      </div>
      <div className={styles["load-movement-items-list"]}>
        {itemsNoLocateds &&
          itemsNoLocateds.map((item) => {
            return (
              <ItemTags
                key={item.sku}
                item={item}
                allSelecteds={allSelecteds}
                quantity={item.tags.length}
                expected={item.expectedUnits}
                handleSelect={handleSelect}
              />
            );
          })}
      </div>
    </div >
  );
  return (
    <div className={styles["reception-order-step-three-container"]}>
      <Step
        title={i18n.t("select.products.and.location")}
        goBackFunc={goBackFunc}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default ReceptionOrderStep3;
